import { useState, useEffect } from 'react';
import { usePlayerStore } from '@/store/player-store';
import HomePage from '@/sections/HomePage';
import LobbyPage from '@/sections/LobbyPage';
import GamePage from '@/sections/GamePage';
import LeaderboardPage from '@/sections/LeaderboardPage';
import ProfilePage from '@/sections/ProfilePage';

type Page = 'home' | 'lobby' | 'game' | 'leaderboard' | 'profile';

function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const { loadProfiles } = usePlayerStore();

  // 初始化时加载档案
  useEffect(() => {
    loadProfiles();
  }, []);

  const handleNavigate = (page: Page) => {
    setCurrentPage(page);
  };

  return (
    <div className="min-h-screen bg-slate-900">
      {currentPage === 'home' && <HomePage onNavigate={handleNavigate} />}
      {currentPage === 'lobby' && <LobbyPage onNavigate={handleNavigate} />}
      {currentPage === 'game' && <GamePage onNavigate={handleNavigate} />}
      {currentPage === 'leaderboard' && <LeaderboardPage onNavigate={handleNavigate} />}
      {currentPage === 'profile' && <ProfilePage onNavigate={handleNavigate} />}
    </div>
  );
}

export default App;
